import { ReviewSurveyData } from '@/components/resources/survey/baseSurvey';
import { MutationTree } from 'vuex';
import { ISurvey, ReviewData } from './types';

const mutations: MutationTree<ISurvey> = {
  setSurveyData(state, reviewData: ReviewData) {
    const originData = state.reviewDataFlatMap.get(getMapKey(reviewData));
    // set reviewDataFlatMap
    state.reviewDataFlatMap.set(getMapKey(reviewData), {
      ...reviewData,
      changeHook: [...(originData?.changeHook || [])]
    });

    // reviewDataMap
    setReviewDataMap(state, reviewData);
  },

  setChangeHook(state, reviewData: ReviewData) {
    if (!reviewData.changeHook) return;
    const mapKey = getMapKey(reviewData);
    const originData = state.reviewDataFlatMap.get(mapKey);
    if (originData) {
      state.reviewDataFlatMap.set(mapKey, {
        ...originData,
        changeHook: Array.from(
          new Set([...(originData.changeHook || []), ...reviewData.changeHook])
        )
      });
    }
  },

  updateSurveyDatas(state, reviewDatas: Array<ReviewData>) {
    reviewDatas.forEach((reviewData) => {
      const originData = state.reviewDataFlatMap.get(getMapKey(reviewData));
      
      // 尝试对比
      const isDiff = contrastDiff(reviewData.content as ReviewSurveyData, originData?.content as ReviewSurveyData);
      if (isDiff) return
      // 有差异则调用回调
      state.reviewDataFlatMap.set(getMapKey(reviewData), {
        ...reviewData,
        changeHook: Array.from(
          new Set([...(originData?.changeHook || []), ...(reviewData?.changeHook || [])])
        )
      });
      // 同步
      setReviewDataMap(state, reviewData);

      // 回调更新
      if (originData?.changeHook) {
        originData.changeHook?.forEach((hook) => {
          hook();
        });
      }
    });
  },

  updateSurveyDataMap(state, surveyDataMap: Map<string, ReviewData>) {
    state.reviewDataFlatMap = surveyDataMap;
    [...surveyDataMap.values()].forEach((item) => {
      setReviewDataMap(state, item);
    });
  },

  clearSurveyDatas(state) {
    state.reviewDataFlatMap = new Map();
    state.reviewDataMap = new Map();
  }
};

export const getMapKey = (reviewData: ReviewData) => {
  return `contentId=${reviewData.contentId}&mark=${reviewData.mark}&step=${reviewData.step}`;
};

const setReviewDataMap = (state: ISurvey, reviewData: ReviewData) => {
  const markData = state.reviewDataMap.get(reviewData.contentId);

  if (markData) {
    // 存在contentId
    if (reviewData.mark) {
      let markMap = new Map();
      if (markData instanceof Map) markMap = markData;
      if (reviewData.step) {
        let setpMap = new Map();
        const stepData = markMap.get(reviewData.mark);
        if (stepData && stepData instanceof Map) setpMap = stepData;
        setpMap.set(reviewData.step, reviewData);
        markMap.set(reviewData.mark, setpMap);
      } else {
        markMap.set(reviewData.mark, reviewData);
      }
      state.reviewDataMap.set(reviewData.contentId, markMap);
    } else {
      state.reviewDataMap.set(reviewData.contentId, reviewData);
    }
    return;
  }

  // 不存在contentId
  let contentData: ReviewData | Map<string, ReviewData | Map<string, ReviewData>> = reviewData;
  if (reviewData.mark) {
    contentData = new Map();

    let markData: ReviewData | Map<string, ReviewData> = reviewData;

    if (reviewData.step) {
      markData = new Map();
      markData.set(reviewData.step, reviewData);
    }

    contentData.set(reviewData.mark, markData);
  }
  state.reviewDataMap.set(reviewData.contentId, contentData);
};

const contrastDiff = (beforeObj: ReviewSurveyData, afterObj: ReviewSurveyData) => {
  if(!afterObj) return false
  if (typeof afterObj === 'string' || typeof afterObj === 'string') return false
  if (beforeObj.type === 'text') {
    return (beforeObj.content as {text: string}).text === (afterObj.content as {text: string}).text
  }
  const beforeItem = beforeObj.content as {checkedNames: Array<string>, picked: string}
  const afterItem = afterObj.content as {checkedNames: Array<string>, picked: string}
  return equar(beforeItem.checkedNames, afterItem.checkedNames) && beforeItem.picked === afterItem.picked
};

function equar(beforeArr: Array<string>, afterArr: Array<string>) {
  if (beforeArr.length !== afterArr.length) return false;

  // 循环遍历数组的值进行比较
  for (let i = 0; i < beforeArr.length; i++) {
    if (beforeArr[i] !== afterArr[i]) {
      return false;
    }
  }
  return true;
}

export default mutations;
